const configRouterOptions = {}
export default {
...configRouterOptions,
}